const yaml = require('js-yaml');

/**
 * Similar to frontmatter, extract metadata and content from text
 * e.g.
 * ---
 * title: "Hello World"
 * date: "2021-09-01"
 * author: "John Doe"
 * ---
 * Lorem ipsum dolor sit amet, consectetur adipiscing elit.
 *
 * @param {string} text - The text to extract metadata from
 * @returns {{[p: string]: any}}
 */
function getMetadataAndContent(text) {
  const parts = text.split('---\n');
  const rawMetadata = parts[1];
  const content = parts.slice(2).join('---\n');

  const metadata = yaml.load(rawMetadata);
  return [metadata, content];
}

module.exports = {
  getMetadataAndContent
};
